import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PriiLogo from '../PriiLogo';

export const LEGAL_CONTACT = 'samburtch9@gmail.com';

/** The shell the Terms and the Privacy Policy share: public pages, signed in or not (the App Store links to them). */
export default function LegalPage({ title, updated, children }) {
  useEffect(() => {
    document.title = `${title} — Prii`;
    return () => {
      document.title = 'Prii';
    };
  }, [title]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-bg transition-colors">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="mb-8">
          <Link to="/" className="inline-block" aria-label="Back to Prii home">
            <PriiLogo size="sm" />
          </Link>
        </div>

        <article className="modal-glass-surface rounded-xl shadow-2xl px-6 sm:px-10 py-8 sm:py-10">
          <header className="mb-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-dark-text">
              {title}
            </h1>
            <p className="mt-2 text-sm text-gray-500 dark:text-dark-muted italic">
              Last updated: {updated}
            </p>
          </header>
          <div className="space-y-8 text-gray-700 dark:text-dark-muted leading-relaxed">
            {children}
          </div>
        </article>
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-dark-text mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

export function Term({ children }) {
  return <strong className="font-semibold text-gray-900 dark:text-dark-text">{children}</strong>;
}

export function ContactLink() {
  return (
    <a href={`mailto:${LEGAL_CONTACT}`} className="text-primary hover:underline font-medium">
      {LEGAL_CONTACT}
    </a>
  );
}
